import { AuthLayout, DefaultLayout } from "@/components/layouts"

export const publicRoute = [{
    path: "*",
    component: () => import("@/views/error/NotFound.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: AuthLayout,
    meta: {
      title: "Login"
    },
  }
]

export const protectedRoute = [{
  path: "/",
  component: DefaultLayout,
  meta: {
    title: "Dashboard",
    group: "apps",
    icon: ""
  },
  redirect: "/dashboard",
  children: [{
      path: "/dashboard",
      name: "Dashboard",
      meta: {
        title: "Dashboard",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/Dashboard.vue")
    },
    {
      path: "/adminlist",
      name: "Admin List",
      meta: {
        title: "Admin List",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AdminList.vue")
    },
    {
      path: "/studentinformation",
      name: "Student Information",
      meta: {
        title: "Student Information",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/StudentList.vue")
    },
    {
      path: "/users",
      name: "Users",
      meta: {
        title: "Users",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/Users.vue")
    },
    {
      path: "/editanswers",
      name: "Edit Answer",
      meta: {
        title: "Edit Answer",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/EditAnswer.vue")
    }
  ]
}]